import TrashIcon from "assets/icons/TrashIcon";
import { Button } from "components/Button";

type TProps = {
  onDelete: (index: number) => void;
  onAdd: () => void;
  onChange: (index: number, value: string) => void;
  rewards: string[];
};

export const Rewards = ({ onAdd, onChange, onDelete, rewards }: TProps) => {
  return (
    <div className="border border-[#FFFFFF40] p-4 rounded-lg">
      <ul className="flex flex-col gap-2 mb-2">
        {rewards.map((reward, i) => (
          <li key={i}>
            <div className="flex items-center justify-between">
              <input
                type="text"
                value={reward}
                onChange={(e) => onChange(i, e.target.value)}
                className="w-full border border-[#FFFFFF40] rounded-lg p-2"
              />
              <button
                onClick={() => onDelete(i)}
                className="ml-2 text-red-500"
                type="button"
              >
                <TrashIcon />
              </button>
            </div>
          </li>
        ))}
      </ul>

      <Button
        onClick={onAdd}
        type="button"
      >
        Add Reward
      </Button>
    </div>
  );
};
